<template lang="pug">
  .default-pdp-v3.xs-f-small.max-at-tweak(v-if="product && product.id" itemprop="product" itemscope itemtype="http://schema.org/Product")
    PdpBanner

    template(v-if="hasActiveSub")
      PdpExistingSubBanner

    DefaultPdpHeroV3

</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';

  import PdpBanner from '@components/PDP/PdpBanner';
  import PdpExistingSubBanner from "@components/PDP/PdpExistingSubBanner";
  import DefaultPdpHeroV3 from './DefaultPdpHeroV3';

  export default {
    name: "DefaultPdpV3",

    components: {
      PdpBanner,
      PdpExistingSubBanner,
      DefaultPdpHeroV3,
    },

    computed: {
      ...mapState('pdp', ['product']),
      ...mapGetters('pdp', ['hasActiveSub']),
    },

    methods: {
      ...mapActions('colorAdvisor', ['isAdvisorCompleted', 'getRootPerfectionRecommendation']),
      ...mapActions('pdp', ['openPurchasePanelModal']),
    },

    created() {
      this.isAdvisorCompleted();

      if (this.$route.query.purchasePanel || this.$route.hash == '#purchase-modal') {
        let modalPayload = {
          theme: 'full-screen'
        };

        this.openPurchasePanelModal(modalPayload);
      }
    },

    mounted() {
      if (this.product && this.product.product_type === 'root_perfection') {
        this.getRootPerfectionRecommendation();
      }
    }
  };
</script>

<style scoped lang="stylus">
</style>
